fragment Document on Document {
  id
  stage
  scanCenter
  createdAt
  updatedAt

  customer {
    ...DocumentCustomer
  }

  rules {
    metadata
    severity
    type
    id
  }

  ...DocumentTagger
  ...DocumentTags
  ...DocumentSender
  ...DocumentSubject
  ...DocumentPaymentMetadata
  ...DocumentNatifMetadata
  ...DocumentScanMetadata
  ...DocumentRecipientMetadata
}
